import Typography from "@nodes/@material-ui/core/Typography";
import Box from "@nodes/@material-ui/core/Box";
import Card from "@nodes/@material-ui/core/Card";
import NumberFormat from "@nodes/react-number-format";
import { phoneNumber } from "../constants";
import { formatPhoneNumber } from "../functions";
import { docMask, docLabel } from "../functions/bankAccounts";

// Payment options for the /bank/account/information/v3 payload.
//
// The only payment-details renderer. Every account carries its OWN holder, so each is
// labelled individually rather than inheriting one global name: an account opened under a
// business name is shown under that business name. A bank holds or rejects a transfer
// whose beneficiary does not match the account, so this is correctness, not decoration.
//
// Do not teach it the older v1/v2 shapes. Those routes stay served for cobro bundles
// cached before v3 shipped, and each of those bundles renders them with its own compiled
// copy of the component it was built with - nothing here has to understand them.
//
// A missing or malformed payload renders the empty state below, never a partial block.
//
// Props:
//   bank    v3 payload: { ACCOUNTS[], CASH_PERSON_NAME?, CASH_PERSON_PHONE?, SUPPORT_PHONE? }
//   action  optional node rendered under the intro line, for a call to action
const RenderBankAccounts = ({ bank = {}, action = null }) => {
  const accounts = Array.isArray(bank.ACCOUNTS) ? bank.ACCOUNTS : [];
  const supportPhone = bank.SUPPORT_PHONE || phoneNumber;

  return (
    <div>
      <Typography variant="body1" paragraph>
        Para hacer un pago mediante transferencia/dep&oacute;sito o en persona, lo puede hacer a travez de los siguiente
        opciones:
      </Typography>

      {action}

      <Typography variant="h6" gutterBottom>
        <b>1. Cuenta de Banco</b>
      </Typography>

      <Typography variant="subtitle1" className="text-info" paragraph>
        <b>
          Por favor, mandar la foto del comprobante de transferencia o deposito, sin comprobante no se aplica el pago!
        </b>
      </Typography>

      <Card variant="outlined" className="mb-2">
        <Box component="div" p={1}>
          {accounts.length === 0 ? (
            <Typography variant="body1">
              No pudimos cargar los datos de la cuenta. Por favor, comun&iacute;quese con la administraci&oacute;n al
              n&uacute;mero de abajo.
            </Typography>
          ) : (
            accounts.map((item, index) => (
              <Box key={`${item.BANK_NAME}-${item.ACC_NUMBER}`} mb={index === accounts.length - 1 ? 0 : 2}>
                <Typography variant="body1">
                  <b>
                    {index + 1}. {item.LABEL_NAME}
                  </b>{" "}
                  No.: {item.ACC_NUMBER}
                </Typography>

                {/* Savings vs checking. A transfer form asks the sender to pick one, and
                    the wrong choice bounces the payment just like a wrong name does. */}
                {item.ACC_TYPE && (
                  <Typography variant="body2" style={{ paddingLeft: "1.4em" }}>
                    Tipo: <b>Cuenta {item.ACC_TYPE}</b>
                  </Typography>
                )}

                {/* Always shown, never inherited: the holder is the field a payer types
                    as the beneficiary, and it differs between these accounts. */}
                {item.OWNER_NAME && (
                  <Typography variant="body2" style={{ paddingLeft: "1.4em" }}>
                    Nombre: <b>{item.OWNER_NAME}</b>
                  </Typography>
                )}

                {item.OWNER_DOC && (
                  <Typography variant="body2" style={{ paddingLeft: "1.4em" }}>
                    {docLabel(item)}:{" "}
                    <NumberFormat value={item.OWNER_DOC} displayType={"text"} format={docMask(item.OWNER_DOC)} />
                  </Typography>
                )}
              </Box>
            ))
          )}
        </Box>
      </Card>

      <br />

      {bank.CASH_PERSON_NAME && (
        <>
          <Typography variant="h6" gutterBottom>
            <b>2. En Persona</b>
          </Typography>

          <Typography variant="body1" paragraph>
            En persona a {bank.CASH_PERSON_NAME}, en el callej&oacute;n de nolis detr&aacute;s del cementerio, se puede
            comunicar al n&uacute;mero de Tel:{" "}
            <a href={`tel:+1${bank.CASH_PERSON_PHONE}`}>{formatPhoneNumber(bank.CASH_PERSON_PHONE)}</a>.
          </Typography>
        </>
      )}

      <Typography variant="body1" gutterBottom>
        <i>
          Comuniquese con la administracion del sistema, en caso de que necesites hacer un acuerdo de pago o para
          cualquier pregunta al n&uacute;mero WhatsApp:
          <a style={{ color: "#000" }} href={`https://wa.me/+1${supportPhone}`}>
            <b> {formatPhoneNumber(supportPhone)}</b>
          </a>
        </i>
      </Typography>
    </div>
  );
};

export default RenderBankAccounts;
